import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import { COMPANY } from "@/lib/siteConfig";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white mt-16">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
        {/* Brand + tagline */}
        <div className="col-span-2">
          <Link to="/" aria-label="SchoolLane – Home" className="inline-block mb-3">
            <Logo height={54} />
          </Link>
          <p className="text-sm text-slate-600 max-w-xs leading-relaxed mt-1">
            School procurement made simple — helping schools manage academic
            books, library books and educational supplies through one
            streamlined workflow.
          </p>
        </div>

        {/* Platform */}
        <div>
          <h4 className="font-semibold text-slate-900 mb-3 text-sm">Platform</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/schools" data-testid="footer-nav-schools">For Schools</Link></li>
            <li><Link to="/parents" data-testid="footer-nav-parents">For Parents</Link></li>
            <li><Link to="/vendors" data-testid="footer-nav-partners">Partner with Us</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className="font-semibold text-slate-900 mb-3 text-sm">Company</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/about" data-testid="footer-nav-about">About Us</Link></li>
            <li><Link to="/contact" data-testid="footer-nav-contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 className="font-semibold text-slate-900 mb-3 text-sm">Legal</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/privacy" data-testid="footer-nav-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-nav-terms">Terms &amp; Conditions</Link></li>
            <li><Link to="/cookies" data-testid="footer-nav-cookies">Cookie Policy</Link></li>
          </ul>
        </div>
      </div>

      {/* Contact block */}
      <div className="border-t border-slate-100 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 py-6 grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
          <div className="flex items-start gap-3">
            <Phone size={16} className="text-blue-700 mt-1 shrink-0" />
            <div>
              <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Phone</div>
              <a href={COMPANY.phoneHref} className="text-slate-800 hover:text-blue-700 font-medium"
                 data-testid="footer-phone">
                {COMPANY.phone}
              </a>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Mail size={16} className="text-blue-700 mt-1 shrink-0" />
            <div>
              <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Email</div>
              <a href={COMPANY.emailHref} className="text-slate-800 hover:text-blue-700 font-medium"
                 data-testid="footer-email">
                {COMPANY.email}
              </a>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <MapPin size={16} className="text-blue-700 mt-1 shrink-0" />
            <div>
              <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Address</div>
              <div className="text-slate-800 font-medium" data-testid="footer-address">
                {COMPANY.address.line1},<br />
                {COMPANY.address.line2},<br />
                {COMPANY.address.line3}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-100 py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} SchoolLane · Made in India for Indian schools.
      </div>
    </footer>
  );
}
